import {Button, Select, Table} from "antd"
import React, {useEffect, useState} from "react"
import {useNavigate, useSearchParams} from "react-router-dom"
import {EnrollmentParameters, IEnrollment} from "../../model/enrollment.model"
import Column from "antd/es/table/Column"
import './enrollment.page.css'
import {useDispatch, useSelector} from "react-redux"
import {pipe} from "fp-ts/function"
import * as O from 'fp-ts/Option'
import * as RA from "fp-ts/ReadonlyArray"
import {RootState} from "../../common/store"
import {paymentActions} from "../../common/store/payment.state"
import * as ES from "../../service/enrollment.service"
import {exportEnrollments} from "../../service/export-handler.service"


export const EnrollmentPage = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const school = useSelector((state: RootState) => state.school)

    const [searchParams] = useSearchParams()

    const [parameters, setParameters] = useState([] as ReadonlyArray<EnrollmentParameters>)
    const [currentParametersId, setCurrentParametersId] = useState<number>()
    const [enrollments, setEnrollments] = useState([] as ReadonlyArray<IEnrollment>)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        dispatch(paymentActions.disable())

        ES.getEnrollmentParameters().subscribe(values => {
                setParameters(values)
                setLoading(false)

                if (parameters.length > 1) {
                    const enrollmentId = searchParams.get('enrollmentId')
                    if (enrollmentId) {
                        const enrollmentOption = pipe(
                            values,
                            RA.findFirst(a => a.id === Number.parseFloat(enrollmentId)),
                        )

                        if (O.isSome(enrollmentOption)) {
                            setCurrentParametersId(enrollmentOption.value.id)
                        }
                    } else {
                        setCurrentParametersId(undefined)
                    }
                } else {
                    setCurrentParametersId(values[0].id)
                }
            }
        )

    }, [])

    useEffect(() => {
        if (currentParametersId) {
            setLoading(true)
            ES.fetchConfirmedEnrollments(school.id!, currentParametersId).subscribe(
                values => {
                    setEnrollments(values)
                    setLoading(false)
                }
            )
        }
    }, [currentParametersId])

    const goToEnrollments = (): void => {
        navigate('/enrollments/new?enrollmentId=' + currentParametersId)
    }

    const getCurrentEnrollmentName = (): string => {
        return pipe(
            parameters,
            RA.findFirst(a => a.id === currentParametersId!),
            O.fold(
                () => 'Ente non trovato',
                a => a.description
            )
        )
    }

    const locale = {
        triggerAsc: 'Clicca per ordinare in modo ascendente',
        triggerDesc: 'Clicca per ordinare in modo discendente'
    }

    return (
        <>
            <div style={{display: "flex", flexDirection: "column"}}>
                <h1 style={{textAlign: "center", fontSize: "30px", marginBottom: "30px"}}>TESSERAMENTO</h1>
                {parameters && <>
                    <div className="enrollments-header-container">
                        {parameters.length > 1 ?
                            <Select
                                style={{margin: "0", width: "200px"}}
                                placeholder="Seleziona un ente"
                                value={currentParametersId}
                                options={parameters.map((item) => ({
                                    label: item.description,
                                    value: item.id
                                }))}
                                onChange={(value) => setCurrentParametersId(value)}
                            />
                            : <div></div>
                        }

                        <div className="enrollments-buttons-container">
                            {currentParametersId && <>
                                <Button
                                    type="default"
                                    onClick={() => exportEnrollments(dispatch, school, currentParametersId!, getCurrentEnrollmentName())}>
                                    Download riepilogo tesserati
                                </Button>
                                <Button type="primary" onClick={() => goToEnrollments()}>
                                    Aggiungi
                                </Button>
                            </>}
                        </div>
                    </div>
                    <Table
                        id="enrollmentsTable"
                        scroll={{x: "max-content"}}
                        dataSource={enrollments}
                        loading={loading}
                        rowKey={(record) => record.fiscalCode + ' ' + Math.random()}
                        locale={locale}
                        pagination={{position: ['bottomCenter']}}>
                        <Column title="Codice fiscale" dataIndex="fiscalCode" key="fiscalCode"
                                sorter={(a: IEnrollment, b: IEnrollment) => a.fiscalCode.localeCompare(b.fiscalCode)}
                                sortDirections={['ascend', 'descend', 'ascend']}/>
                        <Column title="Nome" dataIndex="name" key="name"
                                sorter={(a: IEnrollment, b: IEnrollment) => a.name.localeCompare(b.name)}
                                sortDirections={['ascend', 'descend', 'ascend']}/>
                        <Column title="Cognome" dataIndex="surname" key="surname"
                                sorter={(a: IEnrollment, b: IEnrollment) => a.surname.localeCompare(b.surname)}
                                sortDirections={['ascend', 'descend', 'ascend']}/>
                        <Column title="Classe Solo" dataIndex="classSolo" key="classSolo" align={"center"}/>
                        <Column title="Classe Coppia/Duo" dataIndex="classDuo" key="classDuo" align={"center"}/>
                        <Column title="Classe Gruppo" dataIndex="classGroup" key="classGroup" align={"center"}/>
                        <Column title="Tessera Ente" dataIndex="badge" key="badge"/>
                    </Table>
                </>}
            </div>
        </>
    )
}